<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">
          {{ thirdParty ? 'Edit' : 'Add' }} Third Party
        </h1>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <form-navigation-tabs
            :tabs="tabs"
            v-on:selected="setActive"
            :active="currentView"
          ></form-navigation-tabs>
          <div class="card-body">
            <transition name="component-fade" mode="in-out">
              <third-party-details
                :incident="incident"
                v-if="currentView == 'third_party_details'"
                v-on:created="activateTabs"
                v-on:unsaved-data="saveStatus"
                :third-party="third_party"
              ></third-party-details>

              <third-party-vehicle
                :incident="incident"
                v-if="currentView == 'third_party_vehicle'"
                v-on:unsaved-data="saveStatus"
                :third-party="third_party"
              ></third-party-vehicle>

              <vehicle-location
                :incident="incident"
                :third-party="third_party"
                v-if="currentView == 'vehicle_location'"
                v-on:unsaved-data="saveStatus"
              ></vehicle-location>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThirdPartyDetails from './ThirdParty/ThirdPartyDetails.vue';
import ThirdPartyVehicle from './ThirdParty/ThirdPartyVehicle.vue';
import VehicleLocation from './ThirdParty/VehicleLocation.vue';
import PageHeader from './../../../Shared/PageHeader.vue';

export default {
  components: {
    PageHeader,
    'third-party-details': ThirdPartyDetails,
    'third-party-vehicle': ThirdPartyVehicle,
    'vehicle-location': VehicleLocation
  },

  props: {
    incident: {
      type: String,
      required: true
    },

    thirdParty: {
      type: String
    }
  },

  data() {
    return {
      currentView: 'third_party_details',
      third_party: this.thirdParty,
      tabs: [
        {
          name: 'third_party_details',
          label: 'TP Details',
          disabled: false
        },
        {
          name: 'third_party_vehicle',
          label: 'TP Vehicle',
          disabled: true
        },
        {
          name: 'vehicle_location',
          label: 'Vehicle Location',
          disabled: true
        }
      ]
    };
  },

  mounted() {
    this.mount();
  },

  methods: {
    mount() {
      if (this.thirdParty) {
        this.tabs.forEach(tab => {
          tab.disabled = false;
        });
      }
    },

    setActive(tab) {
      if (this.unsaved_data && this.currentView !== tab) {
        this.saveWarning(tab);
        return;
      }

      this.currentView = tab;
    },

    activateTabs(identifier) {
      this.third_party = identifier;

      this.tabs.forEach(tab => {
        tab.disabled = false;
      });
    },

    saveStatus(event) {
      this.unsaved_data = event;
    },

    saveWarning(tab) {
      window
        .swal({
          title: 'Are you sure?',
          text:
            'You will lose all details entered in this section if you continue!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Continue without saving',
          cancelButtonText: 'Cancel and stay in this section'
        })
        .then(
          () => {
            // Go to selected tab discarding changes
            this.currentView = tab;
            this.unsaved_data = false;
          },
          dismiss => {}
        );
    }
  }
};
</script>
